export function safeText(string, fallback = '-') {
  return string || fallback;
}
